import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/views/layout/index'

Vue.use(Router)

export default new Router({
    routes: [
        {
            path: '/',
            name: 'index',
            meta: {
                title: "首页",
            },
            component: Index,
            children: [
                {
                    path: '',
                    name: 'home',
                    meta: {
                        title: "首页",
                    },
                    component: () => import('@/views/home/index')
                }
            ]
        },
        {
            path: '/login',
            name: 'login',
            meta: {
                title: "登录",
            },
            component: () => import('@/views/core/login'),
        },
        {
            path: '/mobile',
            name: '/mobile',
            component: () => import('@/views/layout-mobile'),
            children: [
                {
                    path: 'login',
                    name: 'login',
                    meta: {
                        title: "登录",
                    },
                    component: () => import('@/views/core/login-mobile'),
                },
                {
                    path: 'jx/inspect/add',
                    name: 'inspect-add',
                    meta: {
                        title: "现场稽查",
                    },
                    component: () => import('@/views/jx/inspect-mobile/add')
                }
            ]
        },
        {
            path: '/system',
            name: 'system',
            component: Index,
            children: [
                {
                    path: 'config',
                    name: 'config',
                    meta: {
                        title: "配置管理",
                    },
                    component: () => import('@/views/system/config')
                },

                {
                    path: 'role',
                    name: 'role',
                    meta: {
                        title: "角色管理",
                    },
                    component: () => import('@/views/system/role')
                },
                {
                    path: 'menu',
                    name: 'menu',
                    meta: {
                        title: "菜单管理",
                    },
                    component: () => import('@/views/system/menu')
                },
                {
                    path: 'dict',
                    name: 'dict',
                    meta: {
                        title: "字典管理",
                    },
                    component: () => import('@/views/system/dict')
                },
                {
                    path: 'user',
                    name: 'user',
                    meta: {
                        title: "用户管理",
                    },
                    component: () => import('@/views/system/user')
                },
                {
                    path: 'video',
                    name: 'video',
                    meta: {
                        title: "视频管理",
                    },
                    component: () => import('@/views/system/video')
                },
                {
                    path: 'log',
                    name: 'log',
                    meta: {
                        title: "操作日志",
                    },
                    component: () => import('@/views/system/log')
                }
            ]
        },
        {
            path: '/jx',
            name: 'jx',
            component: Index,
            children: [
                {
                    path: 'supplier',
                    name: 'supplier',
                    meta: {
                        title: "供应商管理",
                    },
                    component: () => import('@/views/jx/supplier')
                }, {
                    path: 'user',
                    name: 'user',
                    meta: {
                        title: "供应商用户管理",
                    },
                    component: () => import('@/views/jx/user')
                }, {
                    path: 'site',
                    name: 'site',
                    meta: {
                        title: "站点管理",
                    },
                    component: () => import('@/views/jx/site')
                }, {
                    path: 'major-process',
                    name: 'major-process',
                    meta: {
                        title: "专业工序管理",
                    },
                    component: () => import('@/views/jx/major-process')
                }, {
                    path: 'clock',
                    name: 'clock',
                    meta: {
                        title: "施工记录",
                    },
                    component: () => import('@/views/jx/clock')
                }, {
                    path: 'message',
                    name: 'message',
                    meta: {
                        title: "消息公告",
                    },
                    component: () => import('@/views/jx/message')
                }, {
                    path: 'news',
                    name: 'news',
                    meta: {
                        title: "文章管理",
                    },
                    component: () => import('@/views/jx/news')
                }, {
                    path: 'exam',
                    name: 'exam',
                    meta: {
                        title: "考试管理",
                    },
                    component: () => import('@/views/jx/exam')
                }, {
                    path: 'exam-record',
                    name: 'exam-record',
                    meta: {
                        title: "考试情况",
                    },
                    component: () => import('@/views/jx/exam-record')
                }, {
                    path: 'clock-province-report',
                    name: 'clock-province-report',
                    meta: {
                        title: "省级施工报告",
                    },
                    component: () => import('@/views/jx/clock-province-report')
                }, {
                    path: 'object-read',
                    name: 'object-read',
                    meta: {
                        title: "学习情况",
                    },
                    component: () => import('@/views/jx/object-read')
                }, {
                    path: 'inspect',
                    name: 'inspect',
                    meta: {
                        title: "稽查记录",
                    },
                    component: () => import('@/views/jx/inspect')
                }, {
                    path: 'manager-user',
                    name: 'manager-user',
                    meta: {
                        title: "项目经理",
                    },
                    component: () => import('@/views/jx/manager-user')
                }
            ]
        }
    ]
})
